import {  Router } from '@angular/router';
import { MediaObserver } from '@angular/flex-layout';
import { MatSidenav } from '@angular/material/sidenav';
import { Component, OnInit, ViewChild, ViewEncapsulation, Inject } from '@angular/core';

@Component({
  selector: 'clearcals-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LayoutComponent implements OnInit
{
    currentSection: string;
    leftSidenavMode: string;
    leftSidenavOpen: boolean;
    isHintApp: boolean;

    @ViewChild('leftSidenav', {static: true}) sidenav: MatSidenav;

    constructor(
        private router: Router,
        private mediaObserver: MediaObserver,
        @Inject('Window') private window: Window,
    ) {}


    ngOnInit(): void
    {
        this.currentSection = this.router.url.split('#')[0];
        this.isHintApp = /HintApp/i.test(this.window.navigator.userAgent);
        this.calculateSidenavStatus();

        this.sidenav.closedStart.subscribe(() => {
            this.leftSidenavOpen = false;
        });
    }

    calculateSidenavStatus(): void
    {
        const isMobile = this.mediaObserver.isActive('lt-md');
        // Close sidenav on mobile.
        this.leftSidenavOpen = false;
        // Make sidenav open over content on mobile.
        this.leftSidenavMode = isMobile ? 'over' : 'side';
    }

    toggleSidenav(event): void
    {
        this.leftSidenavOpen = event;
    }

    navigate(route): void
    {
        this.sidenav.toggle();
        this.router.navigate([route]);
    }

    openLink(url: string): void
    {
        window.open(url, "_blank");
    }
}
